
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/section/[name]",
      function () {
        return require("private-next-pages/well/section/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/section/[name]"])
      });
    }
  